import React, { FC } from 'react';
import ScreenShotOverlay, {
    IScreenShotOverlayProps
} from 'ts/common/components/gallery/ScreenShotOverlay';
import useScreenshotDeterrence, {
    IUseScreenshotDeterrenceOptions
} from './useScreenshotDeterrence';

/** Keep the overlay above everything else on the page, including the lightbox */
const OVERLAY_Z_INDEX = 2147483647;

interface IScreenshotDeterrenceProps
    extends IUseScreenshotDeterrenceOptions,
        Omit<IScreenShotOverlayProps, 'isKeyboardTrigger' | 'positionStyle'> {}

/** Shows the screenshot warning overlay while a screenshot looks imminent */
const ScreenshotDeterrence: FC<IScreenshotDeterrenceProps> = ({
    keyboardProtectionEnabled,
    windowFocusProtectionLevel,
    onKeyboardAttempt,
    ...overlayProps
}) => {
    const { isKeyboardOverlayShown, isFocusOverlayShown } = useScreenshotDeterrence({
        keyboardProtectionEnabled,
        windowFocusProtectionLevel,
        onKeyboardAttempt
    });

    if (!isKeyboardOverlayShown && !isFocusOverlayShown) {
        return null;
    }

    return (
        <div style={{ position: 'relative', zIndex: OVERLAY_Z_INDEX }}>
            <ScreenShotOverlay {...overlayProps} isKeyboardTrigger={isKeyboardOverlayShown} />
        </div>
    );
};

export default ScreenshotDeterrence;
